import React from 'react';
import { X } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-white py-16 px-4 border-t border-gray-200" data-id="element-218">
      <div className="max-w-3xl mx-auto" data-id="element-219">
        <div className="text-center mb-10" data-id="element-220">
          <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-221">
            El problema que nadie dice en voz alta
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mt-6 leading-tight" data-id="element-222">
            La Mayoría de las Soluciones Fallan por 3 Razones
          </h2>
        </div>

        <div className="mb-10" data-id="element-223">
          <ul className="space-y-6" data-id="element-224">
            {['Los cursos online tienen horas de vídeo que nunca terminás', 'Los manuales técnicos están llenos de términos que no entendés', 'Los vídeos de YouTube no tienen protocolo de seguridad claro'].map((item, idx) => <li key={idx} className="flex items-center gap-4 bg-red-50 p-4 rounded-lg border border-red-100" data-id="element-225">
                <div className="bg-red-200 p-2 rounded-full shrink-0" data-id="element-226">
                  <X className="text-red-700" size={24} strokeWidth={3} data-id="element-227" />
                </div>
                <span className="text-red-900 font-bold text-lg" data-id="element-228">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 font-medium space-y-6 text-center" data-id="element-229">
          <p data-id="element-230">
            El resultado siempre es el mismo. Terminás llamando al electricista
            de todas formas. Y pagando lo que él decida cobrarte.
          </p>
          <p className="text-xl text-gray-900 font-bold" data-id="element-231">
            El problema no es la electricidad. El problema es que nadie creó un
            sistema práctico, paso a paso, diseñado específicamente para alguien
            que no sabe nada de esto.
          </p>
          <p className="text-3xl font-black text-red-600 mt-8" data-id="element-232">Hasta ahora.</p>
        </div>
      </div>
    </section>;
}